import { AxiosResponse } from 'axios';
import apiClient from '.';
const getStrategyTypes = async (userId: string) => {
    const queryParams: any = userId === 'all' ? {} : { user_ids: userId };
    try {
        const { data }: AxiosResponse = await apiClient.getWithAbortController(
            'strategies/types',
            {
                queryParams,
            }
        );
        return data;
    } catch (e: any) {
        return {
            error: e?.response?.data?.error || e?.response?.data?.message,
        };
    }
};
const getStrategies = async (queryParams: Record<string, string>) => {
    const params: any = { ...queryParams };
    if (params?.parent_user_ids === 'all') {
        delete params.parent_user_ids;
    }
    try {
        const { data }: any = await apiClient.getWithAbortController(
            'filters/strategies',
            {
                queryParams: params,
            }
        );
        return data;
    } catch (e: any) {
        return {
            error: e?.response?.data?.error || e?.response?.data?.message,
        };
    }
};
const createStrategies = async (params: Record<string, any>) => {
    try {
        const { data }: any = await apiClient.post('strategies', params);
        if (data.error) {
            return {
                error: data?.error,
            };
        }
        return data;
    } catch (e: any) {
        return {
            error: e?.response?.data?.error || e?.response?.data?.message,
        };
    }
};
const runStrategies = async (params: Record<string, Record<string, any>>) => {
    try {
        const { data }: any = await apiClient.post('strategies/run', {
            ...params,
        });
        return data;
    } catch (e: any) {
        return {
            error:
                e?.response?.data?.error ||
                e?.response?.data?.message ||
                'error',
        };
    }
};
const getStrategyRules = async (queryParams: Record<string, string>) => {
    try {
        const { data }: any = await apiClient.getWithAbortController(
            'strategies/rules',
            {
                queryParams,
            }
        );
        return data;
    } catch (e: any) {
        return {
            error: e?.response?.data?.error || e?.response?.data?.message,
        };
    }
};
const createStrategyTemplates = async (
    params: Record<string, Record<string, any>>
) => {
    try {
        const { data }: any = await apiClient.post('strategies/templates', {
            ...params,
        });
        return data;
    } catch (e: any) {
        return {
            error: e?.response?.data?.error || e?.response?.data?.message,
        };
    }
};

const runStrategyTemplates = async (
    params: Record<string, Record<string, any>>
) => {
    try {
        const { data }: any = await apiClient.post('strategies/templates/run', {
            ...params,
        });
        return data;
    } catch (e: any) {
        return {
            error:
                e?.response?.data?.error ||
                e?.response?.data?.message ||
                'error',
        };
    }
};
export {
    getStrategyTypes,
    getStrategies,
    runStrategies,
    getStrategyRules,
    createStrategies,
    createStrategyTemplates,
    runStrategyTemplates,
};
